// frontend/src/pages/org/org-billing-page.tsx
// Read DESIGN.md before modifying this file.
import { BillingSection } from '@/components/billing/billing-section';
import { RoleGate } from '@/components/auth/role-gate';
import { MemberBillingPlaceholder } from '@/components/auth/member-billing-placeholder';
import { PageContainer } from '@/components/page-container';

/**
 * Billing page (spec Decision 2): org-only, one bill per customer account,
 * pooled usage (P3/P7 re-root, endpoints unchanged). The nav item is hidden
 * for non-admins (OrgSidebar); RoleGate covers deep links with the
 * admin-required placeholder.
 */
export function OrgBillingPage() {
  return (
    <PageContainer variant="fill" className="gap-4">
      <h1 className="text-xl font-semibold">Billing</h1>
      <RoleGate role="admin" fallback={<MemberBillingPlaceholder />}>
        <BillingSection />
      </RoleGate>
    </PageContainer>
  );
}
